import { TportQueryVendorRows } from 'graphql/query/vendor.query';
import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { VendorList } from 'types/vendor.type';
import { PPMS_VENDOR } from 'helpers/constants';

const EMPTY_VENDOR_LIST: VendorList[] = [];

export const useVendorList = () => {
  const { data } = useQuery<{ vendorList: VendorList[] }>(TportQueryVendorRows);

  // `data?.vendorList` is a stable reference from Apollo's cache until the
  // cache entry is updated, so memoizing against it avoids rebuilding (and
  // breaking reference equality for) the filtered list on every render.
  return useMemo(() => {
    if (!data?.vendorList) return EMPTY_VENDOR_LIST;
    return data.vendorList.filter((item) =>
      PPMS_VENDOR.includes(Number(item.id))
    );
  }, [data?.vendorList]);
};
